import { modalState } from '@/state/modal.state';

import { ConfirmDeleteModal } from '../confirm-delete-modal';
import { useDeleteTemplate } from '@/features/settings/manage-templates/use-delete-template.mutation';
import { useAtomValue } from 'jotai';

export function DeleteTemplateModal() {
  const { deleteTemplate } = useDeleteTemplate();

  const modal = useAtomValue(modalState);

  const handleDeleteTemplate = async () => {
    if (!modal || modal.state !== 'deleteTemplate') return;

    await deleteTemplate({ fileId: modal.templateId });
  };

  return <ConfirmDeleteModal onConfirm={handleDeleteTemplate} />;
}
